module.exports = __webpack_public_path__ + "static/media/ulip.c895a57d.mp3";